import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { AddressCardComponent } from './address-card.component';
import { RnplCommonModule } from 'common/src/modules';


@NgModule({
  declarations: [
    AddressCardComponent
  ],
  exports: [
    AddressCardComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RnplCommonModule
  ]
})
export class AddressCardModule { }
